<template>

  <div class="landcover-details">
    <hr/>
    <div v-if="source['meta']['is_static'] == true">
      <p style="margin:5px 0px;;line-height:1.3em;font-size:0.7em;">No data to compare.</p>
    </div>
    <div v-else>

    <h5>Overview of changes to this class:</h5>
    <div class="progress" v-html="changeBars"></div>
    <div class="landcover-mini-legend">
        <label style="margin:0;padding:0;display:inline-block;line-height:0px;margin-right:10px;"><i class="bi bi-circle-fill" style="color:#ff2a00;font-size:0.9em;"></i> Lost</label>
        <label style="margin:0;padding:0;display:inline-block;line-height:0px;margin-right:10px;"><i class="bi bi-circle-fill" style="color:#eeeea8;font-size:0.9em;"></i> Stable</label>
        <label style="margin:0;padding:0;display:inline-block;line-height:0px;margin-right:10px;"><i class="bi bi-circle-fill" style="color:#009908;font-size:0.9em;"></i> Gained</label>
    </div>

    <hr />
    <h5>Losses were converted to:</h5>
    <div class="progress" v-html="lossBars"></div>
    <div class="landcover-mini-legend" v-html="lossLegend"></div>
    <hr />
    <h5>Gains were converted from:</h5>
    <div class="progress" v-html="gainBars"></div>
    <div class="landcover-mini-legend" v-html="gainLegend"></div>

    </div>
    </div>

</template>

<script>
/* eslint-disable */

export default {
    name: 'LandCoverAnalysisDetails',
    components: { },
    props: ['item', 'source', 'resultsLookup', 'changesOnly'],
    data() {
        return {
            mapBackground: null,
        }
    },
    created() {

    },
    updated() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    filters: {

    },
    computed: {
      changeBars() {
        var html = "";
        html += '<div class="progress-bar" style="background-color:#ff2a00;width:'+this.item["loss_perc"]+'%;"></div>';
        html += '<div class="progress-bar" style="background-color:#eeeea8;width:'+this.item["stable_perc"]+'%;"></div>';
        html += '<div class="progress-bar" style="background-color:#009908;width:'+this.item["gain_perc"]+'%;"></div>';
        return html
      },
      lossBars() {
        console.log("Rendering lossbars...")
        console.log("resultsLookup=")
        console.log(this.resultsLookup)
        console.log("Looking up:")
        console.log(this.item["loss_to"])
        var html = "";
        _.forEach(this.item["loss_to"], (lossClass) => {
          html += '<div class="progress-bar" title="'+this.resultsLookup[lossClass[1]]["name"]+'" style="width:'+100*(lossClass[0]/this.item["loss"])+'%;background-color:'+this.resultsLookup[lossClass[1]]["color"]+';"></div>';
          console.log("looked up class="+lossClass[1])
        });
        return html;
      },
      lossLegend() {
        var html = "";
        _.forEach(this.item["loss_to"], (lossClass) => {
          if(100*(lossClass[0]/this.item["loss"]) > 0.1) {
            html += '<label style="margin:0;padding:0;display:inline-block;line-height:0px;margin-right:10px;;"><i class="bi bi-circle-fill" style="color:'+this.resultsLookup[lossClass[1]]["color"]+';font-size:0.9em;position:relative;bottom:0px;"></i> '+this.resultsLookup[lossClass[1]]["name"]+'</label>';
          }
        });
        return html;
      },
      gainBars() {
        var html = "";
        _.forEach(this.item["gain_from"], (gainClass) => {
          html += '<div class="progress-bar" title="'+this.resultsLookup[gainClass[1]]["name"]+'" style="width:'+100*(gainClass[0]/this.item["gain"])+'%;background-color:'+this.resultsLookup[gainClass[1]]["color"]+';"></div>';
        });
        return html;
      },
      gainLegend() {
        var html = "";
        _.forEach(this.item["gain_from"], (gainClass) => {
          if(100*(gainClass[0]/this.item["gain"]) > 0.1) {
            html += '<label style="margin:0;padding:0;display:inline-block;line-height:0px;margin-right:10px;"><i class="bi bi-circle-fill" style="color:'+this.resultsLookup[gainClass[1]]["color"]+';font-size:0.9em;position:relative;bottom:0px;"></i> '+this.resultsLookup[gainClass[1]]["name"]+'</label>';
          }
        });
        return html;
      }
    }
}
</script>
<style>

</style>

<style scoped>
div.landcover-details {
  color:#666;
  padding:0px 0px;
}
div.landcover-details h5 {
  font-size:0.7em;
  font-weight:bold;
  margin-bottom:3px;
}
div.landcover-mini-legend {
  font-size:0.6em;
  line-height:1.5em;
  margin:5px 0px 0px 0px;
}
label.mini {
}
hr {
  margin:8px 0px;
}
</style>